<template>
    <div>
        <el-row>
            <el-col :span='24'>
                <el-steps :active="active" simple>
                    <el-step title="填写企业信息" icon="el-icon-edit"></el-step>
                    <el-step title="上传企业资料" icon="el-icon-upload"></el-step>
                </el-steps>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span='24'>
                    <div v-if="visibleShow" class="contentBox">
                        <div class="content">
                            <el-form :model="ruleForm" :rules="rules" ref="ruleForm"  class="demo-ruleForm">
                                <el-form-item label="企业名称" prop="name" label-width='auto'>
                                    <el-input v-model="ruleForm.name"></el-input>
                                </el-form-item>
                                <el-form-item label="统一信用代码" prop="region" label-width='auto'>
                                    <el-input v-model="ruleForm.region"></el-input>
                                </el-form-item>
                                <el-form-item label="股票代码" prop="date1" label-width='auto'>
                                    <el-input v-model="ruleForm.date1"></el-input>
                                </el-form-item>
                                <el-form-item label="股票简称" prop="date2" label-width='auto'>
                                    <el-input v-model="ruleForm.date2"></el-input>
                                </el-form-item>
                                <el-form-item label="行业分类" prop="delivery" label-width='auto'>
                                    <el-input  v-model='this.$store.state.title'></el-input>
                                </el-form-item>
                                <el-form-item label="经营状态" prop="resource" label-width='auto'>
                                    <el-radio-group v-model="ruleForm.resource">
                                        <el-radio label="存续"></el-radio>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item label="企业性质" prop="desc" label-width='auto'>
                                    <el-radio-group v-model="ruleForm.desc">
                                    <el-radio label="国企"></el-radio>
                                    <el-radio label="民企"></el-radio>
                                    <el-radio label="其他"></el-radio>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item>
                                    <el-button type="primary" @click="submitForm('ruleForm')">下一步</el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                    <div v-else class="uploadBox">
                        <div class="uploadItem">
                                    <p class='uploadP'>公司介绍</p>
                                    <el-upload
                                        class="upload-demo"
                                        drag
                                        limit=1
                                        ref="uploadFile"
                                        :headers="myheader"
                                        :before-upload='handleBefore'
                                        action="/shangPiao/importCmpDebtExcel"
                                        :http-request="uploadFile"
                                        >
                                        <i class="el-icon-upload"></i>
                                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                                        <div class="el-upload__tip" slot="tip">请上传excel表格</div>
                                    </el-upload>
                                </div>
                                <div class="uploadItem">
                                    <p class='uploadP'>十大股东明细</p>
                                    <el-upload
                                        class="upload-demo"
                                        drag
                                        limit=1
                                        ref="uploadFileTop"
                                        :headers="myheader"
                                        :before-upload='handleBefore'
                                        action="/shangPiao/importCmpDebtExcel"
                                        :http-request="uploadFileTop"
                                        >
                                        <i class="el-icon-upload"></i>
                                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                                        <div class="el-upload__tip" slot="tip">请上传excel表格</div>
                                    </el-upload>
                                </div>
                                <div class="uploadItem">
                                    <p class='uploadP'>财务摘要</p>
                                    <el-upload
                                        class="upload-demo"
                                        drag
                                        limit=1
                                        ref="uploadFileMon"
                                        :headers="myheader"
                                        :before-upload='handleBefore'
                                        action="/shangPiao/importCmpDebtExcel"
                                        :http-request="uploadFileMon"
                                        >
                                        <i class="el-icon-upload"></i>
                                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                                        <div class="el-upload__tip" slot="tip">请上传excel表格</div>
                                    </el-upload>
                                </div>
                                <div class="uploadItem">
                                    <p class='uploadP'>偿债指标</p>
                                    <el-upload
                                        class="upload-demo"
                                        drag
                                        limit=1
                                        ref="uploadFileTES"
                                        :headers="myheader"
                                        :before-upload='handleBefore'
                                        action="/shangPiao/importCmpDebtExcel"
                                        :http-request="uploadFileTES"
                                        >
                                        <i class="el-icon-upload"></i>
                                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                                        <div class="el-upload__tip" slot="tip">请上传excel表格</div>
                                    </el-upload>
                                </div>
                                <div class="uploadItem">
                                    <p class='uploadP'>运营能力</p>
                                    <el-upload
                                        class="upload-demo"
                                        drag
                                        limit=1
                                        ref="uploadFileRng"
                                        :headers="myheader"
                                        :before-upload='handleBefore'
                                        action="/shangPiao/importCmpDebtExcel"
                                        :http-request="uploadFileRng"
                                        >
                                        <i class="el-icon-upload"></i>
                                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                                        <div class="el-upload__tip" slot="tip">请上传excel表格</div>
                                    </el-upload>
                                </div>
                                <div class="uploadItem">
                                    <p class='uploadP'>发行债券</p>
                                    <el-upload
                                        class="upload-demo"
                                        drag
                                        limit=1
                                        ref="uploadFileIg"
                                        :headers="myheader"
                                        :before-upload='handleBefore'
                                        action="/shangPiao/importCmpDebtExcel"
                                        :http-request="uploadFileIg"
                                        >
                                        <i class="el-icon-upload"></i>
                                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                                        <div class="el-upload__tip" slot="tip">请上传excel表格</div>
                                    </el-upload>
                                </div>
                                <div class="uploadItem">
                                    <p class='uploadP'>资产负债表</p>
                                    <el-upload
                                        class="upload-demo"
                                        drag
                                        limit=1
                                        ref="uploadFileOmg"
                                        :headers="myheader"
                                        :before-upload='handleBefore'
                                        action="/shangPiao/importCmpDebtExcel"
                                        :http-request="uploadFileOmg"
                                        >
                                        <i class="el-icon-upload"></i>
                                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                                        <div class="el-upload__tip" slot="tip">请上传excel表格</div>
                                    </el-upload>
                                </div>
                                <div class="uploadItem">
                                    <p class='uploadP'>评级信息</p>
                                    <el-upload
                                        class="upload-demo"
                                        drag
                                        :limit='1'
                                        ref="uploadFileFpx"
                                        :headers="myheader"
                                        :before-upload='handleBefore'
                                        action="/shangPiao/importCmpDebtExcel"
                                        :http-request="uploadFileFpx"
                                        >
                                        <i class="el-icon-upload"></i>
                                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                                        <div class="el-upload__tip" slot="tip">请上传excel表格</div>
                                    </el-upload>
                                </div>
                        </div>
            </el-col>
        </el-row>
    </div>
</template>
<script>
export default {
    mounted(){
        this.visibleShow = true;
    },
    props:['msgFather'],
    data(){
        return{
            active: 0,
            visibleShow:true,
            ruleForm: {
                name: '',
                region: '',
                date1: '',
                date2: '',
                delivery: '',
                resource: '存续',
                desc: '国企',
            },
            rules: {
                name: [
                    { required: true, message: '请输入企业名称', trigger: 'blur' },
                ],
                region: [
                    { required: true, message: '请输入统一信用代码', trigger: 'blur' },
                ],
                date1: [
                    { required: true, message: '请输入股票代码', trigger: 'blur' },
                ],
                date2: [
                    { required: true, message: '请输入股票简称', trigger: 'blur' },
                ],
                delivery: [
                    { required: false, message: '请输入行业分类', trigger: 'blur' },
                ],
                resource: [
                    { required: true, message: '请选择经营状态', trigger: 'change' }
                ],
                desc: [
                    { required: true, message: '请选择企业性质', trigger: 'change' }
                ]
            }
        }
    },
    methods:{
        //公司介绍
        uploadFile (item) {
            const fileObj = item.file
            // FormData 对象
            const form = new FormData()
            // 文件对象
            form.append('file', fileObj)
            form.append('organizationCode', this.title)
            // let formTwo = JSON.stringify(form)
            this.ajax.post('/shangPiao/importCmpBase',form)
                    .then(
                        result=>{
                            if(result.data.status=='0000'){
                                this.$message('上传成功！');
                            }else{
                                this.$refs.uploadFile.clearFiles()
                                this.$message(result.data.message);
                            }
                        }
            )
        },
        //十大股东明细
        uploadFileTop (item) {
            const fileObj = item.file
            // FormData 对象
            const form = new FormData()
            // 文件对象
            form.append('file', fileObj)
            form.append('organizationCode', this.title)
            // let formTwo = JSON.stringify(form)
            this.ajax.post('/shangPiao/importCmpShareholderExcel',form)
                    .then(
                        result=>{
                            if(result.data.status=='0000'){
                                this.$message('上传成功！');
                            }else{
                                this.$refs.uploadFileTop.clearFiles()
                                this.$message(result.data.message);
                            }
                        }
            )
        },
        //财务摘要
        uploadFileMon (item) {
            const fileObj = item.file
            // FormData 对象
            const form = new FormData()
            // 文件对象
            form.append('file', fileObj)
            form.append('organizationCode', this.title)
            // let formTwo = JSON.stringify(form)
            this.ajax.post('/shangPiao/importCmpFinanceExcel',form)
                    .then(
                        result=>{
                            if(result.data.status=='0000'){
                                this.$message('上传成功！');
                            }else{
                                this.$refs.uploadFileMon.clearFiles()
                                this.$message(result.data.message);
                            }
                        }
            )
        },
        //偿债指标
        uploadFileTES (item) {
            const fileObj = item.file
            // FormData 对象
            const form = new FormData()
            // 文件对象
            form.append('file', fileObj)
            form.append('organizationCode', this.title)
            // let formTwo = JSON.stringify(form)
            this.ajax.post('/shangPiao/importCmpDebtExcel',form)
                    .then(
                        result=>{
                            if(result.data.status=='0000'){
                                this.$message('上传成功！');
                            }else{
                                this.$refs.uploadFileTES.clearFiles()
                                this.$message(result.data.message);
                            }
                        }
            )
        },
        //运营能力
        uploadFileRng (item) {
            const fileObj = item.file
            // FormData 对象
            const form = new FormData()
            // 文件对象
            form.append('file', fileObj)
            form.append('organizationCode', this.title)
            // let formTwo = JSON.stringify(form)
            this.ajax.post('/shangPiao/importCmpOperationExcel',form)
                    .then(
                        result=>{
                            if(result.data.status=='0000'){
                                this.$message('上传成功！');
                            }else{
                                this.$refs.uploadFileRng.clearFiles()
                                this.$message(result.data.message);
                            }
                        }
            )
        },
        //发行债券
        uploadFileIg (item) {
            const fileObj = item.file
            // FormData 对象
            const form = new FormData()
            // 文件对象
            form.append('file', fileObj)
            form.append('organizationCode', this.title)
            // let formTwo = JSON.stringify(form)
            this.ajax.post('/shangPiao/importCmpBond',form)
                    .then(
                        result=>{
                            if(result.data.status=='0000'){
                                this.$message('上传成功！');
                            }else{
                                this.$refs.uploadFileIg.clearFiles()
                                this.$message(result.data.message);
                            }
                        }
            )
        },
        //资产负债表
        uploadFileOmg (item) {
            const fileObj = item.file
            // FormData 对象
            const form = new FormData()
            // 文件对象
            form.append('file', fileObj)
            form.append('organizationCode', this.title)
            // let formTwo = JSON.stringify(form)
            this.ajax.post('/shangPiao/importCmpBalanceExcel',form)
                    .then(
                        result=>{
                            if(result.data.status=='0000'){
                                this.$message('上传成功！');
                            }else{
                                this.$refs.uploadFileOmg.clearFiles()
                                this.$message(result.data.message);
                            }
                        }
            )
        },
        //评级信息
        uploadFileFpx (item) {
            const fileObj = item.file
            // FormData 对象
            const form = new FormData()
            // 文件对象
            form.append('file', fileObj)
            form.append('organizationCode', this.title)
            // let formTwo = JSON.stringify(form)
            this.ajax.post('/shangPiao/evalation',form)
                    .then(
                        result=>{
                            if(result.data.status=='0000'){
                                this.$message('上传成功！');
                            }else{
                                this.$refs.uploadFileFpx.clearFiles()
                                this.$message(result.message);
                            }
                        }
            )
        },
        handleBefore(file){
            const Xls = file.name.split('.');
            const isLt2M = file.size / 1024 / 1024 < 10;
            if(Xls[1] === 'xls'|| Xls[1] === 'xlsx'){
                return file;
            }else{
                this.$message.error('上传文件只能是 xls/xlsx 格式')
                return false
            }
            if(!isLt2M){
                this.$message.error('上传模板大小不能超过 10MB');
                return false;
            }
        },
        handleChangeVif(){
            this.visibleShow=!this.visibleShow;
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    console.log(this.ruleForm);
                    this.title = this.ruleForm.region;
                    let json = {};
                    json.companyName = this.ruleForm.name;
                    json.organizationCode = this.ruleForm.region;
                    json.industry= this.$store.state.title;
                    json.survivalStatus = this.ruleForm.resource;
                    json.cmpNature = this.ruleForm.desc;
                    json.stockCode = this.ruleForm.date1;
                    json.stockShortName = this.ruleForm.date2
                    this.ajax.post('/shangPiao/cmpAdd',{bizContent: json})
                    .then(
                        result=>{
                        if(result.data.status=='0000'){
                            console.log(result.data.data,'dddddddddddddddddddddddddddddddd');
                            this.$message('企业信息填写成功');
                            this.visibleShow=false;
                            this.active = 1;
                            }
                        }
                    )
                    // this.visibleShow=false;
                } else {
                    console.log('error submit!!');
                return false;
                }
            });
        },
        handleUpload(response, file, fileList){
            console.log(response,file, fileList,'2312312312');
        },
        // handleSave(){
        //     console.log(this.$parent,'ooooooooooooo')
        //     this.$emit("handleChangeDialog");
        //     // this.$parent.handleChangeDialog();
        // }
    }
}
</script>
<style scoped>
.contentBox{
    width: 100%;
    text-align: center;
    margin-top: 15px;
}
.content{
    width: 50%;
    margin: auto;
}
.uploadBox{
    width: 100%;
}
.uploadItem{
    float: left;
    height: 300px;;
    width: 30%;
    margin-left: 3%;
    margin-bottom: 15px;
}
.uploadP{
    color: #343C4EFF;
    font-size: 14px;
    font-weight: 600;
    margin: 5px 0;
}
</style>



// WEBPACK FOOTER //
// src/page/bussinessticket/ticketmessage.vue